module.exports = __webpack_public_path__ + "img/ms-playready.4f59999a.jpg";